import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule, DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, OnDestroy, Output, input } from '@angular/core';
import { Subscription } from 'rxjs';
import { PaymentService } from '../../../services/payment-portal.service';
import { AccountDetails, IPayload, PolicyDetails } from '../../../services/base/policy-details';
import { ProductNamePipe } from '../../pipes/productName.pipe';
import { APP_CONFIG, AppConfig } from '../../../../app.config';
import { ButtonComponent } from "@pacificspecialtyinsurancecompany/psic-ng-components";

@Component({
    selector: 'app-navigation-footer',
    imports: [CommonModule, ProductNamePipe, ButtonComponent],
    templateUrl: './navigation-footer.component.html',
    styleUrls: ['./navigation-footer.component.scss']
})
export class NavigationFooterComponent implements OnDestroy {
    readonly goBack = input<boolean>(false);
    readonly goBackPositionFixed = input<boolean>(true);
    // Continue button presence
    readonly continue = input<boolean>(false);
    // Text to display in continue button
    readonly continueButtonText = input<string>('Continue');
    // Enable/disable continue button
    readonly showButton = input<boolean>(false);
    readonly buttonSize = input<string>('large');
    // To display projected content inside navigation footer
    readonly useContent = input(false);
    // To place continue button either on left or right side of projected content
    readonly continueButtonLeftAlignment = input(false);
    // If false then button will be left aligned else center aligned
    readonly buttonCenterAlignment = input<boolean>(true);
    @Output() navigatePage = new EventEmitter<any>();
    readonly paymentscreen = input<boolean>(false);
    readonly formData = input<any>();
    readonly processingFeeResponse = input<any>();
    readonly showProcessingFee = input<boolean>(false);
    
    isMobile: any;
    sink: Subscription = new Subscription();
    amountSelected: string = '';
    selectedPaymentMethod: boolean = false;
    otherPaymentSelected: boolean = false;
    amount: any;
    viewPolicyInfo: boolean = false;
    paymentDetails: IPayload | null;
    policyNumber: string = '';
    address: string = '';
    policyData:PolicyDetails | undefined;
    accountDetails:AccountDetails;
    currentPolicyTerm:string = '';

    constructor(
        private paymentService: PaymentService,
        public datePipe: DatePipe,
        private breakpointObserver: BreakpointObserver,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {
        this.isMobile = this.breakpointObserver.isMatched('(max-width: 768px)');
        this.sink.add(
            this.breakpointObserver.observe(['(max-width: 768px)']).subscribe((result) => {
                this.isMobile = result.matches;
            })
        );
    }

    ngOnInit(): void {
        if (this.paymentscreen()) {
            this.paymentDetails = this.paymentService.getPaymentDetails();
            this.accountDetails = this.paymentDetails?.retrievePolicyResponse?.details.accountDetail || {} as AccountDetails;
            this.policyData = this.paymentDetails?.retrievePolicyResponse?.details.policyDetails?.at(0);
            this.policyNumber = this.policyData?.policyNumber || '';
            this.address = this.policyData?.insuredAddress + ', ' + this.policyData?.insuredCity + ', ' + this.policyData?.insuredState + ' ' + this.policyData?.insuredZip;
            this.currentPolicyTerm = this.datePipe.transform(this.policyData?.effectiveDate, 'MM/dd/yyyy') + ' - ' + this.datePipe.transform(this.policyData?.expirationDate, 'MM/dd/yyyy');
        }
    }

    ngOnDestroy(): void {
        this.sink.unsubscribe();
    }

    pageNavigation(data: any) {
        this.navigatePage.emit(data);
    }

    redirectToLogin() {
        window.open(this.config.psicLoginUrl, '_blank');
    }

    togglePolicyDetails() {
        this.viewPolicyInfo = !this.viewPolicyInfo;
    }

    /**
     * Calculates total amount due including processing fee if eligible
     * @returns Total amount as string with $ prefix
     */
    getTotalAmountDue(): string {
        const selectedAmount = this.formData().value?.selectedAmtToPay;
        if (!selectedAmount) return '$0.00';

        const processingFeeResponse = this.processingFeeResponse();
        if (processingFeeResponse?.eligible && processingFeeResponse?.convenienceFee && this.showProcessingFee()) {
            let dueToday = selectedAmount.replace('$','');
            let processingFee = processingFeeResponse?.convenienceFee;
            let totalAmountDue = (parseFloat(dueToday) + parseFloat(processingFee)).toFixed(2);
            return `$${totalAmountDue}`;
        }

        return selectedAmount;
    }
}
